import { Directive, ElementRef, HostListener, output, inject } from '@angular/core';

@Directive({
    selector: '[clickOutside]',
    standalone: false
})
export class ClickOutsideDirective {
  private elementRef = inject(ElementRef);


  readonly clickOutside = output<MouseEvent>();

  @HostListener('document:click', ['$event', '$event.target'])
  onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (! targetElement) {
      return;
    }

    const clickedInside = this.elementRef.nativeElement.contains(targetElement);

    if (! clickedInside) {
      this.clickOutside.emit(event);
    }
  }

}
